import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRoute = ({ children, user, allowedRoles }) => {
  // If user is not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user role is not in allowed roles, redirect to their default page
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect based on user role
    if (user.role === 'instructor') {
      return <Navigate to="/instructor" replace />;
    }
    // For admin or other roles, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleBasedRoute;